

import * as React from "react";
import { cn } from "../../Lib/Cn";

const Input = React.forwardRef(({ className, type = "text", ...rest }, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "flex h-9 w-full min-w-0 sahi-radius bg-white px-3 py-1 text-primary transition-all duration-200 outline-none",
        "sahi-input h-11",
        "placeholder:text-muted-foreground",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "selection:bg-primary selection:text-primary-foreground",
        "aria-invalid:border-red-500",
        "text-sm",   // 👈 consistent size
        className
      )}
      {...rest}
    />

  );
});

Input.displayName = "Input";

export { Input };
